var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('register-form', {
    attrs: {
      "onRegister": _vm.handleRegister,
      "onVerifyEmail": _vm.handleVerifyEmail,
      "timer": _vm.timer,
      "onConfirmSmsCode": _vm.confirmSmsCode,
      "onSendSmsCode": _vm.registerSendSmsCode,
      "regions": _vm.regions,
      "orgTypes": _vm.orgTypes
    },
    on: {
      "show-modal": _vm.showModal
    }
  })
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d93ec52","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Register/RegisterFormContainer.vue
// module id = 854
// module chunks = 0